import { cn } from 'helpers/classnames';

export const defaultClasses = cn(
  'border-button-primary flex text-icon-reversed items-center bg-button-transparent h-5 w-5 shrink-0 rounded border p-0 align-middle justify-center ring-offset-white',
  'zappos:border-gray-900 zappos:rounded-sm zappos:outline-gray-900'
);

export const checkedClasses = cn(
  'data-[state=checked]:bg-button-secondary data-[state=checked]:border-button-secondary',
  'zappos:data-[state=checked]:bg-gray-900 zappos:data-[state=checked]:border-gray-900'
);

export const hoverClasses = 'zappos:hover:bg-gray-50';

export const indicatorClasses = 'zappos:text-gray-0';

export const disabledClasses = 'disabled:bg-button-disabled-minimal disabled:border-button-disabled disabled:cursor-not-allowed';

export const focusedClasses = cn(
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
  'zappos:focus-visible:ring-gray-900 zappos:focus-visible:ring-1'
);

export const wrapperClasses = 'inline-flex items-center align-middle gap-2';

export const wrapperHadLabelClasses = cn(
  '[&:has(:focus-visible)]:outline [&:has(:focus-visible)]:outline-button-focus outline-offset-2',
  'zappos:[&:has(:focus-visible)]:outline-gray-900 zappos:[&:has(:focus-visible)]:outline-1'
);

export const labelClasses = cn('text-sm', 'zappos:text-gray-600 zappos:items-center');

export const labelDisabledClasses = 'text-button-disabled-minimal';
